import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import menu from "../API/menu.json";
import Navbar from "../Components/navigation/navbar";
import Menu from "../Components/menu/Menu";
import Chart from "./highchart";
import { AiOutlineMenuFold, AiOutlineEye } from "react-icons/ai";
import { iconSet } from "../images/iconSet.js";
import "../Style/home2023.css";

const defaultData = {
  indicator_id: undefined,
  indicator_name: "Ugyldig indikator",
  description: undefined,
  related_indicators: [],
  related_documents: [],
  sub_title: "Noe gikk galt med visningen av denne indikatoren.",
  origin: undefined,
  stacking: undefined,
  yAxisTitle: undefined,
  graphdata: {
    type: undefined,
    series: [],
  },
};

const HomeRewrite = (props) => {
  const municipalityUrl = new URLSearchParams(useLocation().search).get(
    "municipality",
  );
  const indicatorUrl = new URLSearchParams(useLocation().search).get(
    "indicator",
  );
  const [viewInfobox, setViewInfobox] = useState(true);
  const [menuFilter, setMenuFilter] = useState("Alle");
  const [showRelated] = React.useState(true);

  const [data, setData] = useState(defaultData);

  useEffect(() => {
    const indicator_file_path = `site_${municipalityUrl}/${indicatorUrl}.json`;

    fetch(indicator_file_path)
      .then((res) => res.json())
      .then((data) => {
        setData(data);
      })
      .catch((err) => {
        console.error(err);
        setData(defaultData);
      });
  }, [indicatorUrl, municipalityUrl]);
  const changeMenuFilter = (filter) => {
    setMenuFilter(filter);
  };

  const indicatorDescription = data.description ? (
    <p className="aside-information">{data.description}</p>
  ) : (
    <p className="aside-information">Ingen beskrivelse tilgjengelig</p>
  );

  const relatedDocuments = data.related_documents ? (
    <div className="related-docs-container" style={{ margin: "4%" }}>
      {data.related_documents.map((doc, index) => (
        <a
          key={index}
          className="aside-link"
          href={doc.url}
          target="_blank"
          rel="noreferrer"
          title={doc.description}
          style={{
            display: "block",
            color: "white",
            textDecoration: "underline",
            paddingBottom: "0.5em",
            fontSize: "14px",
          }}
        >
          {doc.title}
        </a>
      ))}
    </div>
  ) : (
    <p className="aside-info-empty">Ingen relaterte dokumenter tilgjengelig</p>
  );

  const relatedIndicators =
    !data.related_indicators || data.related_indicators.length === 0 ? (
      <p className="aside-information">
        Ingen relaterte indikatorer tilgjengelig
      </p>
    ) : (
      data.related_indicators.map((indicator, index) => {
        const foundIcon =
          iconSet.find((el) => el.key === indicator.icon_name) ||
          iconSet.find((el) => el.key === "IoCropOutline");

        return (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              maxWidth: "130px",
            }}
          >
            <div
              key={index}
              style={{
                aspectRatio: "1 / 1",
                borderRadius: "8px",
                backgroundColor: "rgba(255, 255, 255, 0.05)",
                width: "100px",
                margin: "7.5px",
                display: "flex",
                overflow: "hidden",
              }}
            >
              <Link
                to={`/?municipality=${municipalityUrl}&indicator=${indicator.indicator_id}`}
                style={{
                  color: "white",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  textDecoration: "none",
                  width: "100%",
                  height: "100%",
                }}
              >
                <div className="related-indicator-icon">{foundIcon?.icon}</div>

                <p
                  style={{
                    flexGrow: 0,
                    fontSize: "0.75rem",
                    textAlign: "center",
                    fontWeight: "bolder",
                    color: "white",
                    width: "100%",
                    wordBreak: "break-word",
                  }}
                >
                  {indicator.indicator_name}
                </p>
              </Link>
            </div>
          </div>
        );
      })
    );

  return (
    <>
      <main id="maincontainer" style={{ height: "auto" }}>
        <Navbar changeMenuFilter={changeMenuFilter} />
        <div
          className="contentWrapper"
          style={{ display: "flex", flexDirection: "row", zIndex: "2" }}
        >
          <Menu
            municipalityUrl={municipalityUrl}
            dimensions={props.dimensions}
            rolle={menuFilter}
          />
          <div
            className="chartcontainer"
            style={{ width: viewInfobox ? "85%" : "89%", height: "100%" }}
          >
            <section>
              <div className="tabscontainer" style={{ marginTop: "0em" }}>
                {/* <Tabs /> */}
              </div>
              <div
                className="chart"
                style={{
                  height: showRelated
                    ? props.dimensions.height - 200
                    : props.dimensions.height - 80,
                  width: "100%",
                  border: "0px solid pink",
                }}
              >
                <Chart data={data} />
              </div>
              <div
                id="relatedindicators"
                style={{ opacity: showRelated ? 1 : 0, height: "1000px" }}
              >
                <h3 style={{ display: "block" }}>Relaterte Indikatorer</h3>
                <div
                  style={{
                    display: "flex",
                    flexShrink: "1",
                    justifyContent: "flex-start",
                    width: "100%",
                    color: "white",
                  }}
                >
                  {relatedIndicators}
                </div>
              </div>
            </section>
          </div>
          <aside
            className="right-info-wrapper"
            style={{
              display: viewInfobox ? "" : "none",
              transition: "all 0.3s ease",
            }}
          >
            <h3
              className="infoboxheading"
              style={{ textAlign: "center", marginTop: "0.5em" }}
            >
              Informasjon
            </h3>
            <span style={{ position: "relative" }}>
              <AiOutlineEye
                className="toggleInfoBox"
                style={{
                  fontSize: "2em",
                  position: "absolute",
                  top: "-1.5em",
                  right: "0",
                }}
                onClick={() => setViewInfobox(!viewInfobox)}
              />
              <div
                style={{
                  flexDirection: "column",
                  justifyContent: "space-evenly",
                  height: "100%",
                }}
              >
                <section style={{}}>
                  <h3>Om Indikatoren</h3>
                  <div
                    style={{
                      borderBottom: "1px solid var(--nav-bg-color)",
                    }}
                  >
                    {indicatorDescription}
                  </div>
                </section>
                <section style={{}}>
                  <h3>Relaterte dokumenter</h3>
                  {relatedDocuments}
                </section>
              </div>
            </span>
          </aside>
          {viewInfobox !== true ? (
            <span
              className="expandinfobox"
              title="Hvis informasjon"
              style={{
                margin: "auto",
                cursor: "pointer",
                position: "relative",
              }}
              onClick={() => setViewInfobox(true)}
            >
              <AiOutlineMenuFold
                style={{ fontSize: "4em", color: "white", margin: "auto" }}
              />
            </span>
          ) : null}
        </div>
      </main>
    </>
  );
};

export default HomeRewrite;
